import React from "react";
import { EVALUATION_STATUS, statusLabel } from "./evaluationUtils";

/** Self-assessment gray · For rating amber · Waiting for employee purple · Contested amber · Completed green · Cancelled red */
const EvaluationStatusBadge = ({ evaluation }) => {
  const tone = EVALUATION_STATUS[evaluation.status]?.tone || "gray";
  return (
    <span className={`status-pill status-pill--${tone}`}>
      {statusLabel(evaluation)}
    </span>
  );
};

export default EvaluationStatusBadge;
